export default "__VITE_ASSET__BjzB7vxE__"